import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
// removed makeStyles as it was unused
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import FlagIcon from '@material-ui/icons/Flag';
import GroupIcon from '@material-ui/icons/Group';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import EventIcon from '@material-ui/icons/Event';
// removed LabelIcon and LinkIcon since labels/dependencies UI is removed
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';


const inivalue = {
    project_name: "",
    summary: "",
    priority: "No priority",
    start_date: "",
    target_date: "",
    // labels and dependencies removed from UI; keep if API expects them
    description: "",
    milestones: [],
    lead_id: "",
    member_ids: []
};

const AddProject = (props) => {
    const classes = props;
    const [project, setProject] = useState(inivalue);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showMilestoneForm, setShowMilestoneForm] = useState(false);
    const [milestoneDraft, setMilestoneDraft] = useState({ name: "", description: "", dueDate: "" });
    const history = useHistory();
    const [allUsers, setAllUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);

    useEffect(() => {
        if (props && props.authToken === false) {
            // history.push('/login');
        }
    }, [props, history]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'start_date') {
            setProject(prev => {
                const nextTarget = prev.target_date && value && prev.target_date < value ? "" : prev.target_date;
                return { ...prev, [name]: value, target_date: nextTarget };
            });
        } else if (name === 'target_date') {
            if (project.start_date && value && value < project.start_date) {
                swal({
                    title: "Invalid target date",
                    text: "Target date cannot be before start date",
                    icon: "warning",
                });
                return;
            }
            setProject({ ...project, [name]: value });
        } else {
            setProject({ ...project, [name]: value });
        }
    };

    const handleMilestoneDraftChange = (e) => {
        const { name, value } = e.target;
        setMilestoneDraft({ ...milestoneDraft, [name]: value });
    };

    const handleAddMilestone = () => {
        if (!milestoneDraft.name) {
            return;
        }
        const updated = [
            ...project.milestones,
            { name: milestoneDraft.name, description: milestoneDraft.description, dueDate: milestoneDraft.dueDate }
        ];
        setProject({ ...project, milestones: updated });
        setMilestoneDraft({ name: "", description: "", dueDate: "" });
        setShowMilestoneForm(false);
    };

    const handleRemoveMilestone = (index) => {
        const updated = project.milestones.filter((_, i) => i !== index);
        setProject({ ...project, milestones: updated });
    };

    // Load users and filter only logged users
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setIsLoadingUsers(true);
                const response = await AuthApi.getData();
                
                // Check if response has the expected structure
                let list = [];
                if (response && response.status === true && Array.isArray(response.data)) {
                    list = response.data;
                } else if (Array.isArray(response)) {
                    list = response;
                } else if (response && Array.isArray(response.data)) {
                    list = response.data;
                }
                
                // Filter users - use the correct field name 'user_logged' as seen in other components
                const filtered = list.filter((u) => {
                    return u?.user_logged === 1;
                });
                
                // If no users found with filtering, show all users as fallback
                if (filtered.length === 0 && list.length > 0) {
                    setAllUsers(list);
                } else {
                    setAllUsers(filtered);
                }
            } catch (e) {
                console.error("Error fetching users:", e);
                setAllUsers([]);
            } finally {
                setIsLoadingUsers(false);
            }
        };
        fetchUsers();
    }, []);

    const validate = (values) => {
        let errors = {};
        if (!values.project_name) {
            errors.project_name = "Cannot be blank";
        }
        if (values.start_date && values.target_date && values.target_date < values.start_date) {
            errors.target_date = "Target date cannot be before start date";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormErrors(validate(project));
        setIsSubmitting(true);
    };

    useEffect(() => {
        const submitProject = async () => {
            swal({
                title: "Loading",
                text: "Please wait...",
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
                width: "10%",
                content: createSwalLoaderNode()
            });
            try {
                console.log("Submitting project:", project);
                let create = await AuthApi.createProject(project);
                swal.close();
                if (create && create.status === true) {
                    history.push('/project');
                } else {
                    swal({
                        title: "OOPS!",
                        icon: "error",
                        text: create.message || "Something went wrong, Please try later!"
                    });
                }
            } catch (error) {
                swal.close();
                console.error("Error creating project:", error);
                swal({
                    title: "Error",
                    icon: "error",
                    text: "An error occurred while creating the project. Please try again later."
                });
            }
        };

        if (Object.keys(formErrors).length === 0 && isSubmitting) {
            submitProject();
        }
    }, [formErrors, isSubmitting, history, project]);

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Project"
                                    primaryPageLink="/project"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Project" />
                            </CardContent>
                        </Card>

                        {/* {
                            props.authToken === false ? <AuthCheckComponent authToken={props.authToken} /> : ""
                        } */}
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root} variant="outlined" style={{ borderRadius: 10 }}>
                                    <CardContent>

                                        <Typography variant="h2">Add Project</Typography>
                                        <Box mt={2} mb={1}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <Chip
                                                        icon={<FiberManualRecordIcon style={{ color: '#ffa726' }} />}
                                                        label="Backlog"
                                                        variant="default"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Chip icon={<FlagIcon />} label={project.priority || 'No priority'} size="small" variant="outlined" />
                                                </Grid>
                                                <Grid item>
                                                    <Chip icon={<GroupIcon />} label="Lead" size="small" variant="outlined" />
                                                </Grid>
                                                <Grid item>
                                                    <Chip icon={<GroupIcon />} label="Members" size="small" variant="outlined" />
                                                </Grid>
                                                <Grid item>
                                                    <Chip icon={<PlayCircleOutlineIcon />} label="Start" size="small" variant="outlined" />
                                                </Grid>
                                                <Grid item>
                                                    <Chip icon={<EventIcon />} label="Target" size="small" variant="outlined" />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <form className={`${classes.form} project-form-fields`} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="Project"
                                                        name="project_name"
                                                        label="Project name"
                                                        variant="outlined"
                                                        error={formErrors.project_name && true}
                                                        value={project.project_name}
                                                        onChange={handleChange}
                                                        className={formErrors.project_name && "input-error"}
                                                    />
                                                    {formErrors.project_name && (
                                                        <span className="error">{formErrors.project_name}</span>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        name="summary"
                                                        label="Add a short summary"
                                                        variant="outlined"
                                                        value={project.summary}
                                                        onChange={handleChange}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth variant="outlined">
                                                        <InputLabel id="lead-label">Lead</InputLabel>
                                                        <Select
                                                            labelId="lead-label"
                                                            label="Lead"
                                                            name="lead_id"
                                                            value={project.lead_id}
                                                            onChange={handleChange}
                                                            disabled={isLoadingUsers}
                                                            renderValue={(selected) => {
                                                                if (isLoadingUsers) return "Loading users...";
                                                                const u = allUsers.find((x) => String(x.id) === String(selected));
                                                                if (!u) return "";
                                                                const label = u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`);
                                                                return (
                                                                    <Box display="flex" alignItems="center">
                                                                        <Avatar 
                                                                            src={u.photo ? u.photo : ""} 
                                                                            style={{ width: 24, height: 24, marginRight: 8 }}
                                                                        >
                                                                            {u.firstName ? u.firstName.charAt(0).toUpperCase() : (u.name ? u.name.charAt(0).toUpperCase() : "U")}
                                                                        </Avatar>
                                                                        {label}
                                                                    </Box>
                                                                );
                                                            }}
                                                        >
                                                            {isLoadingUsers ? (
                                                                <MenuItem disabled>Loading users...</MenuItem>
                                                            ) : allUsers.length === 0 ? (
                                                                <MenuItem disabled>No users available</MenuItem>
                                                            ) : (
                                                                allUsers.map((user) => (
                                                                    <MenuItem key={user.id} value={user.id}>
                                                                        <Checkbox checked={String(project.lead_id) === String(user.id)} />
                                                                        <Box display="flex" alignItems="center">
                                                                            <Avatar 
                                                                                src={user.photo ? user.photo : ""} 
                                                                                style={{ width: 24, height: 24, marginRight: 8 }}
                                                                            >
                                                                                {user.firstName ? user.firstName.charAt(0).toUpperCase() : (user.name ? user.name.charAt(0).toUpperCase() : "U")}
                                                                            </Avatar>
                                                                            <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth variant="outlined">
                                                        <InputLabel id="members-label">Members</InputLabel>
                                                        <Select
                                                            labelId="members-label"
                                                            label="Members"
                                                            multiple
                                                            name="member_ids"
                                                            value={project.member_ids}
                                                            disabled={isLoadingUsers}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setProject({ ...project, member_ids: typeof value === 'string' ? value.split(',') : value });
                                                            }}
                                                            renderValue={(selected) => {
                                                                if (isLoadingUsers) return "Loading users...";
                                                                const ids = Array.isArray(selected) ? selected : [];
                                                                return (
                                                                    <Box display="flex" flexWrap="wrap" gridGap={4}>
                                                                        {ids.map((id) => {
                                                                            const u = allUsers.find((x) => String(x.id) === String(id));
                                                                            if (!u) return null;
                                                                            const label = u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`);
                                                                            return (
                                                                                <Tooltip key={id} title={label}>
                                                                                    <Avatar 
                                                                                        src={u.photo ? u.photo : ""} 
                                                                                        style={{ width: 24, height: 24 }}
                                                                                    >
                                                                                        {u.firstName ? u.firstName.charAt(0).toUpperCase() : (u.name ? u.name.charAt(0).toUpperCase() : "U")}
                                                                                    </Avatar>
                                                                                </Tooltip>
                                                                            );
                                                                        })}
                                                                    </Box>
                                                                );
                                                            }}
                                                        >
                                                            {isLoadingUsers ? (
                                                                <MenuItem disabled>Loading users...</MenuItem>
                                                            ) : allUsers.length === 0 ? (
                                                                <MenuItem disabled>No users available</MenuItem>
                                                            ) : (
                                                                allUsers.map((user) => (
                                                                    <MenuItem key={user.id} value={user.id}>
                                                                        <Checkbox checked={project.member_ids.map(String).includes(String(user.id))} />
                                                                        <Box display="flex" alignItems="center">
                                                                            <Avatar 
                                                                                src={user.photo ? user.photo : ""} 
                                                                                style={{ width: 24, height: 24, marginRight: 8 }}
                                                                            >
                                                                                {user.firstName ? user.firstName.charAt(0).toUpperCase() : (user.name ? user.name.charAt(0).toUpperCase() : "U")}
                                                                            </Avatar>
                                                                            <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl fullWidth variant="outlined">
                                                        <InputLabel id="priority-label">Priority</InputLabel>
                                                        <Select
                                                            labelId="priority-label"
                                                            label="Priority"
                                                            name="priority"
                                                            value={project.priority}
                                                            onChange={handleChange}
                                                        >
                                                            <MenuItem value="No priority">No priority</MenuItem>
                                                            <MenuItem value="Low">Low</MenuItem>
                                                            <MenuItem value="Medium">Medium</MenuItem>
                                                            <MenuItem value="High">High</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        label="Start"
                                                        name="start_date"
                                                        type="date"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={project.start_date}
                                                        onChange={handleChange}
                                                        onClick={(e) => {
                                                            try { e.target.showPicker(); } catch (err) {}
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        label="Target"
                                                        name="target_date"
                                                        type="date"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={project.target_date}
                                                        onChange={handleChange}
                                                        onClick={(e) => {
                                                            try { e.target.showPicker(); } catch (err) {}
                                                        }}
                                                        inputProps={{ min: project.start_date || undefined }}
                                                        error={formErrors.target_date && true}
                                                    />
                                                    {formErrors.target_date && (
                                                        <span style={{ color: 'red', fontSize: '0.75rem', marginTop: '4px', display: 'block' }}>{formErrors.target_date}</span>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        name="description"
                                                        label="Write a description, a project brief, or collect ideas..."
                                                        variant="outlined"
                                                        multiline
                                                        rows={4}
                                                        value={project.description}
                                                        onChange={handleChange}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={3} style={{ marginTop: 16 }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h6">Milestones</Typography>
                                                    <Card variant="outlined" style={{ borderRadius: 10 }}>
                                                        <CardContent>
                                                            {project.milestones.length === 0 ? (
                                                                <Typography color="textSecondary">No milestones yet</Typography>
                                                            ) : (
                                                                <List dense>
                                                                    {project.milestones.map((m, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <ListItem>
                                                                                <ListItemText
                                                                                    primary={m.name}
                                                                                    secondary={m.dueDate ? `Due ${m.dueDate}` : m.description}
                                                                                />
                                                                                <ListItemSecondaryAction>
                                                                                    <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveMilestone(index)}>
                                                                                        <CloseIcon />
                                                                                    </IconButton>
                                                                                </ListItemSecondaryAction>
                                                                            </ListItem>
                                                                            {index < project.milestones.length - 1 && <Divider />}
                                                                        </React.Fragment>
                                                                    ))}
                                                                </List>
                                                            )}

                                                            {!showMilestoneForm && (
                                                                <Box display="flex" justifyContent="flex-end">
                                                                    <Button startIcon={<AddIcon />} variant="outlined" color="primary" onClick={() => setShowMilestoneForm(true)}>
                                                                        Add milestone
                                                                    </Button>
                                                                </Box>
                                                            )}

                                                            {showMilestoneForm && (
                                                                <div style={{ marginTop: 12 }}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Milestone name"
                                                                                name="name"
                                                                                variant="outlined"
                                                                                value={milestoneDraft.name}
                                                                                onChange={handleMilestoneDraftChange}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Add a description"
                                                                                name="description"
                                                                                variant="outlined"
                                                                                value={milestoneDraft.description}
                                                                                onChange={handleMilestoneDraftChange}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Due date"
                                                                                name="dueDate"
                                                                                type="date"
                                                                                variant="outlined"
                                                                                InputLabelProps={{ shrink: true }}
                                                                                value={milestoneDraft.dueDate}
                                                                                onChange={handleMilestoneDraftChange}
                                                                                onClick={(e) => {
                                                                                    try { e.target.showPicker(); } catch (err) {}
                                                                                }}
                                                                                inputProps={{ 
                                                                                    min: project.start_date || undefined 
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                    <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end' }}>
                                                                        <Button className="btn-cancel" onClick={() => setShowMilestoneForm(false)}>Cancel</Button>
                                                                        <Button color="primary" variant="contained" onClick={handleAddMilestone}>Add milestone</Button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={12} style={{ display: 'flex', gap: 12 }}>
                                                    <Button type="submit" variant="contained" color="primary">Create project</Button>
                                                    <Button type="button" className="btn-cancel" onClick={(e) => { e.preventDefault(); history.push('/project'); }}>Cancel</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={6}></Grid>
                        </Grid>
                    </div>
                } />
            <Footer />
        </div>
    );
};

export default AddProject;
